// extracted by mini-css-extract-plugin
module.exports = {"tabbar":"TabbarNav_tabbar__2tUEE"};